import React from 'react'

const RecommendIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'>
      <path
        d='M2.593 14.86a1.75 1.75 0 0 0 1.93-.379L8 11.036l3.477 3.445a1.75 1.75 0 0 0 1.933.38 1.738 1.738 0 0 0 1.09-1.632V3.943A2.952 2.952 0 0 0 11.545 1h-7.09A2.952 2.952 0 0 0 1.5 3.943v9.286a1.738 1.738 0 0 0 1.093 1.631z'
        fill='#4E9749'
        fillRule='nonzero'
      />
    </svg>
  )
}

export default RecommendIcon
